import React, { useState } from "react";
import moment from "moment";
import axios from "axios";

import Modal from "./Modal";
import AuthContext from "../../context/auth-context";
import { Button, Form, FormGroup, ModalFooter, Spinner } from "reactstrap";
import { useHistory } from "react-router-dom";
// import history from "../../history";

const Item = ({
  task,
  user,
  updateTasks,
  taskArchival,
  taskType,
  taskDeletion,
}) => {
  const {
    _id,
    name,
    description,
    dueDate,
    label,
    status,
    archivedOn,
    createdAt,
    updatedAt,
  } = task;

  let history = useHistory();

  const [modal, setModal] = useState(false);
  const [loading, toggleLoading] = useState(false);
  const [newStatus, changeStatus] = useState(task.status);
  const [cur, changeCur] = useState("update");

  const toggle = () => setModal(!modal);

  const allStatus = ["New", "In Progress", "Completed"];

  //update task
  const updateTask = async (e, token, createMessage, history) => {
    e.preventDefault();
    toggleLoading(true);
    changeCur("update");
    let res;
    const body = { ...task, status: newStatus };
    try {
      if (body.status === "Completed") {
        res = await axios.patch(
          ` https://myhacktaskmanager.herokuapp.com/api/tasks/archive/${_id}`,
          body,
          {
            params: {
              ui: task.creator.toString(),
            },
            headers: {
              "Content-Type": "application/json",
              "x-auth-token": `${token}`,
            },
          }
        );
        taskArchival(res.data.task);
      } else {
        res = await axios.patch(
          ` https://myhacktaskmanager.herokuapp.com/api/tasks/${_id}`,
          body,
          {
            params: {
              ui: task.creator.toString(),
            },
            headers: {
              "Content-Type": "application/json",
              "x-auth-token": `${token}`,
            },
          }
        );
        updateTasks(res.data.task);
      }
      createMessage(true, res.data.msg);
      toggleLoading(false);
      toggle();
    } catch (err) {
      if (err.response) {
        await createMessage(false, err.response.data.msg);
        toggleLoading(false);
        toggle();
        history.push("/auth");
        let pathUrl = window.location.href;
        window.location.href = pathUrl;
      }
    }
  };

  //Delete Task
  const deleteTask = async (e, token, createMessage, history) => {
    e.preventDefault();
    toggleLoading(true);
    changeCur("delete");
    try {
      const res = await axios.delete(
        ` https://myhacktaskmanager.herokuapp.com/api/tasks/${_id}`,
        {
          params: {
            ui: task.creator.toString(),
            t: taskType === "createdTasks" ? "created" : "archived",
          },
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": `${token}`,
          },
        }
      );
      taskDeletion(task);
      await createMessage(true, res.data.msg);
      toggleLoading(false);
    } catch (err) {
      if (err.response) {
        await createMessage(false, err.response.data.msg);
        toggleLoading(false);
        toggle();
        history.push("/auth");
      }
    }
  };

  return (
    <AuthContext.Consumer>
      {(context) => {
        return (
          <React.Fragment>
            <Modal modal={modal} toggle={toggle} title={name}>
              {taskType === "createdTasks" ? (
                <Form
                  onSubmit={(e) =>
                    updateTask(e, context.token, context.createMessage, history)
                  }
                >
                  <FormGroup>
                    <p>
                      <b>Description:</b>
                      <br />
                      {description}
                    </p>
                  </FormGroup>
                  <FormGroup>
                    <p
                      style={
                        dueDate < new Date().toISOString()
                          ? { color: "red" }
                          : { color: "green" }
                      }
                    >
                      <b>Due Date</b>: {moment(dueDate).format("MMM Do YYYY")} @{" "}
                      {moment(dueDate).fromNow()}
                    </p>
                  </FormGroup>
                  <FormGroup>
                    <p>
                      <b>Label</b>: {label}
                    </p>
                  </FormGroup>
                  <FormGroup>
                    <p>
                      <b>Status</b>: {status}
                    </p>
                    <select
                      className="form-control"
                      value={newStatus}
                      onChange={(e) => changeStatus(e.target.value)}
                    >
                      {allStatus.map((status, i) => (
                        <option key={i} value={status}>
                          {status}
                        </option>
                      ))}
                    </select>
                  </FormGroup>
                  <FormGroup>
                    <p>
                      <b>Created On</b>:{" "}
                      {moment(createdAt).format("MMM Do YYYY")}
                    </p>
                  </FormGroup>
                  <FormGroup>
                    <p>
                      <b>Updated On</b>:{" "}
                      {moment(updatedAt).format("MMM Do YYYY")}
                    </p>
                  </FormGroup>
                  <FormGroup>
                    <p>
                      <b>Created By</b>: {user && user.name}
                    </p>
                  </FormGroup>
                  <ModalFooter className="justify-content-between">
                    <Button
                      color="danger"
                      type="submit"
                      onClick={(e) =>
                        deleteTask(
                          e,
                          context.token,
                          context.createMessage,
                          history
                        )
                      }
                    >
                      Delete &nbsp;
                      {loading && cur === "delete" && (
                        <>
                          &nbsp;
                          <Spinner
                            color="white"
                            size="sm"
                            className="smallSpinner"
                          />
                          &nbsp;
                        </>
                      )}
                    </Button>{" "}
                    <div>
                      <Button
                        className="mr-1"
                        color="primary"
                        type="submit"
                        value="Submit"
                      >
                        Update &nbsp;
                        {loading && cur === "update" && (
                          <>
                            &nbsp;
                            <Spinner
                              color="white"
                              size="sm"
                              className="smallSpinner"
                            />
                            &nbsp;
                          </>
                        )}
                      </Button>{" "}
                      <Button color="secondary" onClick={toggle}>
                        Cancel
                      </Button>
                    </div>
                  </ModalFooter>
                </Form>
              ) : (
                <>
                  <p>
                    <b>Description:</b>
                    <br />
                    {description}
                  </p>
                  <p
                    style={
                      dueDate < new Date().toISOString()
                        ? { color: "red" }
                        : { color: "green" }
                    }
                  >
                    <b>Due Date</b>: {moment(dueDate).format("MMM Do YYYY")} @{" "}
                    {moment(dueDate).fromNow()}
                  </p>
                  <p>
                    <b>Label</b>: {label}
                  </p>
                  <p>
                    <b>Status</b>: {status}
                  </p>
                  <p>
                    <b>Created On</b>: {moment(createdAt).format("MMM Do YYYY")}
                  </p>
                  <p>
                    <b>Archived On</b>:{" "}
                    {moment(archivedOn).format("MMM Do YYYY")}
                  </p>
                  <p>
                    <b>Created By</b>: {user && user.name}
                  </p>
                  <ModalFooter>
                    <Button
                      className="text-left"
                      color="danger"
                      type="submit"
                      onClick={(e) =>
                        deleteTask(e, context.token, context.createMessage)
                      }
                    >
                      Delete &nbsp;
                      {loading && cur === "delete" && (
                        <>
                          &nbsp;
                          <Spinner
                            color="white"
                            size="sm"
                            className="smallSpinner"
                          />
                          &nbsp;
                        </>
                      )}
                    </Button>{" "}
                    <Button color="secondary" onClick={toggle}>
                      Cancel{" "}
                    </Button>
                  </ModalFooter>
                </>
              )}
            </Modal>
            <li
              className="item"
              style={
                dueDate.toString() > new Date().toISOString()
                  ? { borderColor: "green" }
                  : { borderColor: "red" }
              }
              onClick={() => {
                context.createMessage(false, null);
                toggle();
              }}
            >
              <span>{name}</span>
              <span>{moment(dueDate).format("L")}</span>
              <div>
                <span>{label}</span>
                <span>{status}</span>
              </div>
            </li>
          </React.Fragment>
        );
      }}
    </AuthContext.Consumer>
  );
};

export default Item;
